/* ChroMorpher redesigned pages - tabs, gallery filter, resilient video. No dependencies. */
(function () {
  'use strict';
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Tab groups */
  $$('[data-cmp-tabs]').forEach(function (group) {
    var tabs = $$('[role="tab"]', group);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (o) {
          var on = o === t;
          o.setAttribute('aria-selected', String(on));
          var panel = document.getElementById(o.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t), n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); n.focus(); n.click(); }
      });
    });
  });

  /* Gallery filter */
  var gal = document.querySelector('[data-cmp-gallery]');
  if (gal) {
    var items = $$('[data-cat]', gal);
    var pills = $$('[data-filter]');
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var f = p.getAttribute('data-filter');
        pills.forEach(function (o) { o.setAttribute('aria-pressed', String(o === p)); });
        var shown = 0;
        items.forEach(function (it) {
          var match = f === 'all' || it.getAttribute('data-cat') === f;
          it.hidden = !match;
          if (match) shown++;
        });
        var live = document.getElementById('cmp-gal-count');
        if (live) live.textContent = shown + (shown === 1 ? ' photo' : ' photos');
      });
    });
  }

  /* Videos: drop any tile the browser cannot decode so the band never shows a dead box.
     Two of the source clips are QuickTime, which some browsers refuse. */
  (function () {
    var band = document.querySelector('[data-cmp-videos]');
    if (!band) return;
    var figs = $$('figure', band);
    var alive = figs.length;
    figs.forEach(function (fig) {
      var v = fig.querySelector('video');
      if (!v) return;
      var drop = function () {
        if (!fig.parentNode) return;
        fig.parentNode.removeChild(fig);
        alive--;
        if (alive <= 0) band.hidden = true;
      };
      v.addEventListener('error', drop);
      if (v.canPlayType) {
        var t = (v.currentSrc || v.src || '').indexOf('.mov') > -1 ? 'video/quicktime' : 'video/mp4';
        if (v.canPlayType(t) === '') drop();
      }
    });
  })();

  /* Smooth in-page anchors */
  $$('a[href^="#cmp-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
})();